export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  status: string;
  description: string;
  chapters: ComicChapter[];
  updateTime: string;
  views: number;
  rating: number;
  tags: string[];
  featured: boolean;
}

export const categories = [
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line' },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line' },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line' },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line' },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line' },
  { name: '都市', slug: 'dushi', icon: 'ri-building-line' },
  { name: '武侠', slug: 'wuxia', icon: 'ri-sword-line' },
  { name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '洞洞杂货铺',
    author: '墨香',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20illustration%20of%20a%20mysterious%20curiosity%20shop%20owner%20standing%20in%20a%20cozy%20vintage%20store%20filled%20with%20magical%20artifacts%2C%20soft%20warm%20lighting%2C%20detailed%20anime%20art%20style%2C%20clean%20simple%20background%20with%20wooden%20shelves%2C%20artistic%20composition&width=600&height=800&seq=comic-001&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: '连载中',
    description: '在城市的角落里，有一家不起眼的小店——洞洞杂货铺。店主阿洞是个神秘的年轻人，他出售的每件物品背后都藏着一段不为人知的故事。无论是失意者、迷茫者，还是心怀梦想的人，走进这家店，总能找到改变命运的神奇之物。但代价，却各有不同……这是一部关于人性、选择与成长的奇幻漫画，带你走进一个充满想象力的世界。',
    chapters: [
      { id: 'ch-001-1', title: '第1话 杂货铺的客人', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-001-2', title: '第2话 第一个愿望', number: 2, updateDate: '2026-08-02' },
      { id: 'ch-001-3', title: '第3话 镜中的秘密', number: 3, updateDate: '2026-08-03' },
      { id: 'ch-001-4', title: '第4话 神秘来客', number: 4, updateDate: '2026-08-04' },
      { id: 'ch-001-5', title: '第5话 命运的交易', number: 5, updateDate: '2026-08-05' },
      { id: 'ch-001-6', title: '第6话 光影交错', number: 6, updateDate: '2026-08-06' },
      { id: 'ch-001-7', title: '第7话 抉择时刻', number: 7, updateDate: '2026-08-07' },
    ],
    updateTime: '2026-08-07',
    views: 158200,
    rating: 9.6,
    tags: ['奇幻', '治愈', '单元剧', '人性'],
    featured: true,
  },
  {
    id: 'comic-002',
    title: '烈焰战士',
    author: '疾风',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20cover%20of%20a%20young%20warrior%20wielding%20a%20flaming%20sword%20in%20battle%20pose%2C%20intense%20action%20scene%20with%20fire%20effects%2C%20anime%20art%20style%2C%20clean%20heroic%20composition%20on%20simple%20orange%20tinted%20background&width=600&height=800&seq=comic-002&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    description: '在一个被火焰之力统治的世界里，少年炎烈意外觉醒了远古火神之力。他必须踏上征途，在一次次生死战斗中磨砺自己，寻找失落的火神遗迹，联合各地勇士，对抗黑暗势力的入侵。一场关于勇气与信念的史诗战斗即将展开！',
    chapters: [
      { id: 'ch-002-1', title: '第1话 觉醒之日', number: 1, updateDate: '2026-07-20' },
      { id: 'ch-002-2', title: '第2话 初次试炼', number: 2, updateDate: '2026-07-22' },
      { id: 'ch-002-3', title: '第3话 炎之试炼场', number: 3, updateDate: '2026-07-25' },
      { id: 'ch-002-4', title: '第4话 宿敌登场', number: 4, updateDate: '2026-07-28' },
      { id: 'ch-002-5', title: '第5话 火神遗迹', number: 5, updateDate: '2026-08-01' },
    ],
    updateTime: '2026-08-01',
    views: 213500,
    rating: 9.3,
    tags: ['热血', '战斗', '冒险', '成长'],
    featured: true,
  },
  {
    id: 'comic-003',
    title: '星辰下的约定',
    author: '月影',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20cover%20scene%20of%20a%20couple%20standing%20under%20a%20starry%20night%20sky%2C%20gentle%20atmosphere%20with%20cherry%20blossom%20petals%2C%20soft%20pastel%20colors%2C%20anime%20art%20style%2C%20simple%20dreamy%20composition&width=600&height=800&seq=comic-003&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '已完结',
    description: '高中生林星辰与转学生苏晚晴在图书馆偶然相遇，一段纯真的校园恋情悄然萌芽。然而，两人家庭的秘密、朋友的误解、梦想的分歧，让这段感情充满了挑战。他们能否穿越现实的迷雾，兑现星空下的约定？温暖治愈的校园恋爱故事。',
    chapters: [
      { id: 'ch-003-1', title: '第1话 图书馆的邂逅', number: 1, updateDate: '2026-05-10' },
      { id: 'ch-003-2', title: '第2话 同桌的日常', number: 2, updateDate: '2026-05-15' },
      { id: 'ch-003-3', title: '第3话 星空的誓言', number: 3, updateDate: '2026-05-20' },
    ],
    updateTime: '2026-06-30',
    views: 98700,
    rating: 9.5,
    tags: ['恋爱', '校园', '治愈', '青春'],
    featured: false,
  },
  {
    id: 'comic-004',
    title: '学霸也疯狂',
    author: '小九',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20manhua%20cover%20of%20a%20panicked%20student%20with%20exaggerated%20expressions%20surrounded%20by%20floating%20books%20and%20test%20papers%2C%20comedic%20anime%20style%2C%20bright%20vibrant%20colors%2C%20simple%20yellow%20background&width=600&height=800&seq=comic-004&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    description: '全校第一的学霸赵明智，其实有一个不可告人的秘密——他所有的知识都是在睡梦中学会的！为了守住这个秘密，他每天都要假装努力学习，却闹出了无数令人捧腹的笑话。当新来的转学生意外发现了他的秘密后，校园生活变得更加疯狂。',
    chapters: [
      { id: 'ch-004-1', title: '第1话 学霸的秘密', number: 1, updateDate: '2026-08-02' },
      { id: 'ch-004-2', title: '第2话 转学生的挑战', number: 2, updateDate: '2026-08-04' },
      { id: 'ch-004-3', title: '第3话 考试大作战', number: 3, updateDate: '2026-08-06' },
    ],
    updateTime: '2026-08-06',
    views: 76200,
    rating: 9.1,
    tags: ['搞笑', '校园', '日常', '轻松'],
    featured: true,
  },
  {
    id: 'comic-005',
    title: '迷雾之城',
    author: '暗夜行者',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20manhua%20cover%20showing%20a%20detective%20silhouette%20in%20a%20foggy%20city%20street%20at%20night%2C%20noir%20atmosphere%2C%20suspenseful%20mood%2C%20anime%20art%20style%2C%20simple%20dark%20blue%20toned%20background&width=600&height=800&seq=comic-005&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    description: '一座被迷雾笼罩的城市，每隔七天就会发生一起无法解释的案件。私家侦探沈墨被卷入其中，随着调查深入，他发现所有线索都指向一个隐藏在城市深处的古老秘密。真相与谎言交织，每一个角色都有着不为人知的暗面。',
    chapters: [
      { id: 'ch-005-1', title: '第1话 第七天的钟声', number: 1, updateDate: '2026-07-15' },
      { id: 'ch-005-2', title: '第2话 迷雾中的线索', number: 2, updateDate: '2026-07-20' },
      { id: 'ch-005-3', title: '第3话 消失的目击者', number: 3, updateDate: '2026-07-25' },
      { id: 'ch-005-4', title: '第4话 暗处的眼睛', number: 4, updateDate: '2026-07-30' },
    ],
    updateTime: '2026-07-30',
    views: 124300,
    rating: 9.4,
    tags: ['悬疑', '推理', '都市', '暗黑'],
    featured: false,
  },
  {
    id: 'comic-006',
    title: '都市修罗',
    author: '天蚕',
    cover: 'https://readdy.ai/api/search-image?query=A%20cool%20Chinese%20manhua%20cover%20of%20a%20stylish%20young%20man%20in%20modern%20city%20business%20attire%20with%20a%20confident%20smirk%2C%20urban%20skyline%20background%2C%20anime%20art%20style%2C%20clean%20sophisticated%20composition&width=600&height=800&seq=comic-006&orientation=portrait',
    category: '都市',
    categorySlug: 'dushi',
    status: '连载中',
    description: '退役兵王陈天宇回归都市，本想低调做一个普通人，却接连遇到各种势力挑衅。从商战到地下世界，他凭借超凡实力一步步走向巅峰。但更大的阴谋正在暗中酝酿，这座城市的水，远比表面看起来更深。',
    chapters: [
      { id: 'ch-006-1', title: '第1话 王者归来', number: 1, updateDate: '2026-07-10' },
      { id: 'ch-006-2', title: '第2话 初露锋芒', number: 2, updateDate: '2026-07-15' },
      { id: 'ch-006-3', title: '第3话 商场风云', number: 3, updateDate: '2026-07-20' },
      { id: 'ch-006-4', title: '第4话 暗流涌动', number: 4, updateDate: '2026-07-25' },
      { id: 'ch-006-5', title: '第5话 地下拳赛', number: 5, updateDate: '2026-07-30' },
      { id: 'ch-006-6', title: '第6话 幕后黑手', number: 6, updateDate: '2026-08-03' },
    ],
    updateTime: '2026-08-03',
    views: 186400,
    rating: 9.2,
    tags: ['都市', '逆袭', '战斗', '商战'],
    featured: true,
  },
  {
    id: 'comic-007',
    title: '剑道无双',
    author: '剑客行',
    cover: 'https://readdy.ai/api/search-image?query=A%20majestic%20Chinese%20manhua%20cover%20of%20a%20swordsman%20in%20traditional%20hanfu%20robes%20standing%20on%20a%20mountain%20peak%20with%20sword%20drawn%2C%20ancient%20Chinese%20painting%20inspired%20anime%20style%2C%20ink%20wash%20effect%2C%20simple%20elegant%20composition&width=600&height=800&seq=comic-007&orientation=portrait',
    category: '武侠',
    categorySlug: 'wuxia',
    status: '连载中',
    description: '少年剑客叶孤鸿出身寒微，却怀揣成为天下第一剑客的梦想。他拜入隐世剑宗，历经磨难修炼绝世剑法。然而江湖风云变幻，正邪之争一触即发，他必须在剑道与道义之间做出选择。一部致敬经典武侠的诚意之作。',
    chapters: [
      { id: 'ch-007-1', title: '第1话 少年与剑', number: 1, updateDate: '2026-06-20' },
      { id: 'ch-007-2', title: '第2话 拜师学艺', number: 2, updateDate: '2026-06-25' },
      { id: 'ch-007-3', title: '第3话 初入江湖', number: 3, updateDate: '2026-07-01' },
      { id: 'ch-007-4', title: '第4话 剑宗试炼', number: 4, updateDate: '2026-07-10' },
      { id: 'ch-007-5', title: '第5话 风云际会', number: 5, updateDate: '2026-07-20' },
    ],
    updateTime: '2026-07-20',
    views: 145600,
    rating: 9.5,
    tags: ['武侠', '剑道', '江湖', '成长'],
    featured: false,
  },
  {
    id: 'comic-008',
    title: '星际漂流记',
    author: '宇航',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20Chinese%20manhua%20cover%20of%20a%20young%20astronaut%20floating%20in%20space%20with%20a%20distant%20galaxy%20nebula%20behind%2C%20sci-fi%20anime%20style%2C%20deep%20space%20colors%2C%20simple%20cosmic%20composition&width=600&height=800&seq=comic-008&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    status: '连载中',
    description: '公元2350年，人类已遍布银河系。少年林宇航在一次太空探索中意外穿越虫洞，来到一个完全未知的星系。在这里，他遇到了各种奇异的外星文明，并发现自己身上隐藏着改变宇宙格局的力量。宏大的星际冒险就此展开。',
    chapters: [
      { id: 'ch-008-1', title: '第1话 虫洞奇遇', number: 1, updateDate: '2026-07-01' },
      { id: 'ch-008-2', title: '第2话 异星文明', number: 2, updateDate: '2026-07-08' },
      { id: 'ch-008-3', title: '第3话 星际联盟', number: 3, updateDate: '2026-07-15' },
    ],
    updateTime: '2026-07-15',
    views: 89200,
    rating: 9.0,
    tags: ['科幻', '星际', '冒险', '未来'],
    featured: false,
  },
  {
    id: 'comic-009',
    title: '魔法学院优等生',
    author: '魔法少女控',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20Chinese%20manhua%20cover%20of%20students%20in%20robes%20casting%20colorful%20spells%20in%20a%20medieval%20magic%20academy%20hall%2C%20fantasy%20anime%20style%2C%20bright%20magical%20effects%2C%20simple%20enchanting%20composition&width=600&height=800&seq=comic-009&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: '已完结',
    description: '普通高中生白小羽收到一封来自异世界的入学通知书——她被魔法学院录取了！在这个充满魔法与奇迹的世界里，她结识了一群志同道合的伙伴，一起学习、成长，对抗黑暗魔法势力。充满欢乐与感动的魔法校园故事。',
    chapters: [
      { id: 'ch-009-1', title: '第1话 入学通知书', number: 1, updateDate: '2026-03-01' },
      { id: 'ch-009-2', title: '第2话 魔法初体验', number: 2, updateDate: '2026-03-10' },
      { id: 'ch-009-3', title: '第3话 学院大冒险', number: 3, updateDate: '2026-03-20' },
      { id: 'ch-009-4', title: '第4话 最终考验', number: 4, updateDate: '2026-04-01' },
    ],
    updateTime: '2026-04-15',
    views: 135700,
    rating: 9.4,
    tags: ['奇幻', '魔法', '校园', '冒险'],
    featured: false,
  },
  {
    id: 'comic-010',
    title: '厨神传说',
    author: '食客行',
    cover: 'https://readdy.ai/api/search-image?query=A%20mouthwatering%20Chinese%20manhua%20cover%20of%20a%20young%20chef%20holding%20a%20wok%20with%20flames%20and%20delicious%20dishes%20around%2C%20food%20anime%20style%2C%20warm%20kitchen%20atmosphere%2C%20simple%20appetizing%20composition&width=600&height=800&seq=comic-010&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    description: '街头小厨阿福意外获得一本上古厨神秘籍，从此厨艺飞升！他踏上了挑战各地厨神的爆笑之旅，每一道菜背后都有一个温暖人心的故事。美食与欢笑交织，这是一部让你看着看着就饿了的漫画！',
    chapters: [
      { id: 'ch-010-1', title: '第1话 神秘食谱', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-010-2', title: '第2话 黑暗料理对决', number: 2, updateDate: '2026-08-03' },
      { id: 'ch-010-3', title: '第3话 传说中的炒饭', number: 3, updateDate: '2026-08-05' },
    ],
    updateTime: '2026-08-05',
    views: 67200,
    rating: 8.9,
    tags: ['搞笑', '美食', '竞技', '治愈'],
    featured: false,
  },
  {
    id: 'comic-011',
    title: '修罗王妃',
    author: '凤歌',
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Chinese%20manhua%20cover%20of%20an%20elegant%20woman%20in%20ancient%20Chinese%20royal%20red%20wedding%20dress%20with%20golden%20ornaments%2C%20palace%20background%2C%20historical%20romance%20anime%20style%2C%20simple%20luxurious%20composition&width=600&height=800&seq=comic-011&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '连载中',
    description: '现代女医生苏婉穿越成为冷宫废妃，凭借医术和智慧在波谲云诡的后宫中步步为营。她本想低调求生，却意外卷入了皇权争夺的旋涡。冷面王爷与机智医妃，一场跨越时空的深情虐恋。',
    chapters: [
      { id: 'ch-011-1', title: '第1话 穿越冷宫', number: 1, updateDate: '2026-07-05' },
      { id: 'ch-011-2', title: '第2话 妙手回春', number: 2, updateDate: '2026-07-12' },
      { id: 'ch-011-3', title: '第3话 王爷驾到', number: 3, updateDate: '2026-07-19' },
      { id: 'ch-011-4', title: '第4话 宫闱暗斗', number: 4, updateDate: '2026-07-26' },
      { id: 'ch-011-5', title: '第5话 倾城之恋', number: 5, updateDate: '2026-08-02' },
    ],
    updateTime: '2026-08-02',
    views: 198300,
    rating: 9.6,
    tags: ['恋爱', '古风', '穿越', '宫斗'],
    featured: true,
  },
  {
    id: 'comic-012',
    title: '末日生存法则',
    author: '末世行者',
    cover: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20Chinese%20manhua%20cover%20of%20survivors%20in%20ragged%20clothes%20standing%20in%20a%20ruined%20cityscape%2C%20dramatic%20moody%20lighting%2C%20survival%20anime%20style%2C%20simple%20desolate%20composition&width=600&height=800&seq=comic-012&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    description: '一场突如其来的病毒席卷全球，城市沦为废墟，幸存者们在末世中艰难求生。普通上班族陆铭必须带领一小群幸存者穿越废土，前往传说中的安全区。但在这条路上，最大的威胁不是怪物，而是人心。',
    chapters: [
      { id: 'ch-012-1', title: '第1话 灾难降临', number: 1, updateDate: '2026-06-15' },
      { id: 'ch-012-2', title: '第2话 逃离城市', number: 2, updateDate: '2026-06-22' },
      { id: 'ch-012-3', title: '第3话 废土求生', number: 3, updateDate: '2026-06-30' },
      { id: 'ch-012-4', title: '第4话 人心难测', number: 4, updateDate: '2026-07-08' },
    ],
    updateTime: '2026-07-08',
    views: 112400,
    rating: 9.3,
    tags: ['悬疑', '末日', '生存', '人性'],
    featured: false,
  },
  {
    id: 'comic-013',
    title: '拳霸天下',
    author: '铁拳',
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20Chinese%20manhua%20cover%20of%20a%20muscular%20fighter%20wearing%20boxing%20gloves%20in%20a%20ring%20with%20dramatic%20spotlight%2C%20sports%20action%20anime%20style%2C%20intense%20competitive%20atmosphere%2C%20simple%20bold%20composition&width=600&height=800&seq=comic-013&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    status: '已完结',
    description: '落魄拳手高猛被所有人看低，但他从未放弃冠军梦想。在神秘教练的指导下，他通过地狱般的训练脱胎换骨，一步步从地下拳场打到世界擂台。用拳头证明自己的热血励志故事，每一拳都震撼人心！',
    chapters: [
      { id: 'ch-013-1', title: '第1话 落魄拳手', number: 1, updateDate: '2026-04-01' },
      { id: 'ch-013-2', title: '第2话 神秘教练', number: 2, updateDate: '2026-04-10' },
      { id: 'ch-013-3', title: '第3话 地狱特训', number: 3, updateDate: '2026-04-20' },
      { id: 'ch-013-4', title: '第4话 首战告捷', number: 4, updateDate: '2026-05-01' },
      { id: 'ch-013-5', title: '第5话 世界擂台', number: 5, updateDate: '2026-05-15' },
      { id: 'ch-013-6', title: '第6话 冠军之战', number: 6, updateDate: '2026-05-30' },
    ],
    updateTime: '2026-06-10',
    views: 176500,
    rating: 9.4,
    tags: ['热血', '格斗', '竞技', '励志'],
    featured: false,
  },
  {
    id: 'comic-014',
    title: '总裁的替身新娘',
    author: '甜心',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20cover%20of%20a%20woman%20in%20white%20wedding%20dress%20and%20a%20handsome%20man%20in%20suit%2C%20modern%20luxury%20setting%2C%20CEO%20romance%20anime%20style%2C%20simple%20elegant%20composition&width=600&height=800&seq=comic-014&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '连载中',
    description: '平凡女孩安小冉被迫代替双胞胎姐姐嫁给冷酷总裁陆景琛。她以为这是一场毫无感情的商业联姻，却不知总裁早已看穿一切。当替身身份逐渐暴露，两人的感情却已悄然变化。霸道总裁爱上我的甜蜜故事。',
    chapters: [
      { id: 'ch-014-1', title: '第1话 替嫁之夜', number: 1, updateDate: '2026-07-18' },
      { id: 'ch-014-2', title: '第2话 总裁的试探', number: 2, updateDate: '2026-07-22' },
      { id: 'ch-014-3', title: '第3话 心跳的距离', number: 3, updateDate: '2026-07-28' },
      { id: 'ch-014-4', title: '第4话 身份危机', number: 4, updateDate: '2026-08-03' },
    ],
    updateTime: '2026-08-03',
    views: 221800,
    rating: 9.5,
    tags: ['恋爱', '总裁', '替身', '甜蜜'],
    featured: true,
  },
  {
    id: 'comic-015',
    title: '灵异侦探社',
    author: '鬼手',
    cover: 'https://readdy.ai/api/search-image?query=A%20spooky%20Chinese%20manhua%20cover%20of%20a%20young%20detective%20holding%20a%20glowing%20talisman%20in%20a%20haunted%20old%20mansion%20corridor%2C%20supernatural%20horror%20anime%20style%2C%20eerie%20atmosphere%2C%20simple%20dark%20composition&width=600&height=800&seq=comic-015&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    description: '大学生莫凡拥有一双能看见鬼魂的眼睛，他与几个同样拥有特殊能力的伙伴组建了"灵异侦探社"，专门解决各种超自然事件。从校园怪谈到都市传说，每一个案件都扣人心弦，恐怖中带着人性的温度。',
    chapters: [
      { id: 'ch-015-1', title: '第1话 阴阳眼', number: 1, updateDate: '2026-07-08' },
      { id: 'ch-015-2', title: '第2话 图书馆怪谈', number: 2, updateDate: '2026-07-14' },
      { id: 'ch-015-3', title: '第3话 废弃病院', number: 3, updateDate: '2026-07-21' },
      { id: 'ch-015-4', title: '第4话 镜中世界', number: 4, updateDate: '2026-07-28' },
    ],
    updateTime: '2026-07-28',
    views: 103600,
    rating: 9.2,
    tags: ['悬疑', '灵异', '侦探', '恐怖'],
    featured: false,
  },
  {
    id: 'comic-016',
    title: '异世界便利店',
    author: '懒猫',
    cover: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Chinese%20manhua%20cover%20of%20a%20convenience%20store%20in%20a%20fantasy%20world%20with%20elves%20and%20magical%20creatures%20shopping%2C%20colorful%20isekai%20anime%20style%2C%20bright%20cheerful%20composition&width=600&height=800&seq=comic-016&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    description: '普通便利店店员周小凡意外穿越到剑与魔法的异世界，他唯一带过去的是一家完整的便利店！从此，异世界的居民们疯狂爱上了薯片、可乐和泡面。周小凡一边经营便利店，一边应对各路勇者、魔王和公主们的奇葩需求。',
    chapters: [
      { id: 'ch-016-1', title: '第1话 便利店穿越了', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-016-2', title: '第2话 魔王爱薯片', number: 2, updateDate: '2026-08-03' },
      { id: 'ch-016-3', title: '第3话 公主的泡面', number: 3, updateDate: '2026-08-06' },
    ],
    updateTime: '2026-08-06',
    views: 94800,
    rating: 9.0,
    tags: ['搞笑', '穿越', '异世界', '日常'],
    featured: false,
  },
];

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((c) => c.categorySlug === slug);
};

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};

export const getFeaturedComics = (): Comic[] => {
  return comics.filter((c) => c.featured);
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, limit);
};

export const getHotComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};